import Alert from "client/common/components/content/Alert";
import { useFeatures } from "client/clinics/hooks";

/** For a client whose date of birth on file is under the minimum age an item's policy sets. */
const ClientUnderAgeAlert = () => {
  const isGranularControlsEnabled = useFeatures().CONTROLLED_SUBSTANCE_GRANULAR_CONTROLS;

  return (
    <Alert variant="warning">
      {isGranularControlsEnabled
        ? "You must be 18 or older to place this order."
        : "You must be 18 or older to order controlled substances."}{" "}
      Please be sure to enter your date of birth, not your pet&apos;s.
    </Alert>
  );
};

export default ClientUnderAgeAlert;
